import { useEffect, useRef } from "react";

export const useDetectClickOutsideWithExclude = (handler, excludedIds = []) => {
    const ref = useRef(null);
  
    useEffect(() => {
      const listener = (event) => {
        // Check if the click is on the ref element
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
  
        // Check if the clicked element or its parents have one of the excluded IDs
        let clickedElement = event.target;
        while (clickedElement) {
          if (excludedIds.includes(clickedElement.id)) {
            return; // Exclude this element if it has one of the excluded IDs
          }
          clickedElement = clickedElement.parentElement; // Move up the DOM tree
        }
  
        handler(event); // Trigger the handler if clicked outside and no excluded element
      };
  
      document.addEventListener('mouseup', listener);
      document.addEventListener('touchstart', listener);
  
      return () => {
        document.removeEventListener('mouseup', listener);
        document.removeEventListener('touchstart', listener);
      };
    }, [handler, excludedIds]);
  
    return ref;
  };